// @ts-ignore
import 'common/js/links-bar';

const activeButtonClass = 'share-article__active-button';
const positionClassStatic = 'share-article_static';
const positionClassFixed = 'share-article_fixed';
const copyButtons = document.querySelectorAll('[data-js-share-article-copy-button]') as NodeListOf<HTMLElement>;
const shareArticleBlock = document.querySelector('[data-js-share-article-block]') as HTMLElement;
const shareArticleWrapper = document.querySelector('[data-js-share-article-wrapper]') as HTMLElement;
const contentBlock = document.querySelector('[data-js-content-block]') as HTMLElement;
const shareArticleTopElement = document.querySelector('[data-js-share-article-top]') as HTMLElement;

copyButtons.forEach((button) => {
    button?.addEventListener('click', () => {
        navigator.clipboard.writeText(window.location.href);
        button.classList.add(activeButtonClass);

        setTimeout(() => button.classList.remove(activeButtonClass), 2000);
    });
});

const setShareButtonsPosition = () => {
    const setElementPosition = (element, position) => {
        switch (position) {
            case 'fixed':
                element.classList.add(positionClassFixed);
                element.classList.remove(positionClassStatic);
                break;
            case 'static':
                element.classList.add(positionClassStatic);
                element.classList.remove(positionClassFixed);
                break;
            default:
                break;
        }
    };

    const margin: number = shareArticleTopElement?.parentElement?.offsetTop ?? 0;

    shareArticleBlock.style.top = `${margin}px`;

    if (shareArticleBlock.getBoundingClientRect().top > 60) {
        setElementPosition(shareArticleWrapper, 'static');

        return;
    }

    if (shareArticleBlock.style.top === `${margin}px}` || shareArticleBlock.style.top !== '0px') {
        // eslint-disable-next-line
        const topPositionValue = -1 * (shareArticleBlock.getBoundingClientRect().top + window.pageYOffset - margin);

        shareArticleBlock.style.top = `${topPositionValue}px`;
    }

    if (window.innerWidth < 1294) {
        setElementPosition(shareArticleWrapper, 'static');

        shareArticleWrapper.classList.add(positionClassStatic);
        shareArticleWrapper.classList.remove(positionClassFixed);
        return;
    }

    setElementPosition(shareArticleWrapper, 'fixed');
    const rectWrapper: DOMRect = shareArticleWrapper.getBoundingClientRect();
    const rectContent: DOMRect = contentBlock.getBoundingClientRect();
    // eslint-disable-next-line max-len
    const heightLeft = rectContent.height + rectContent.top - rectWrapper.top - rectWrapper.height;

    if (heightLeft <= 0) {
        if (shareArticleWrapper && shareArticleBlock) {
            shareArticleWrapper.classList.add(positionClassStatic);
            shareArticleWrapper.classList.remove(positionClassFixed);
            shareArticleBlock.style.top = `${rectContent.height - rectWrapper.height - 45}px`; // 45px is distance between 'shareArticleTopElement' and real position where article share buttons div is placed
        }
    }
};

const addWindowListener = (eventType) => {
    window.addEventListener(eventType, setShareButtonsPosition);
};

setShareButtonsPosition();

if (shareArticleWrapper && contentBlock && shareArticleBlock) {
    ['scroll', 'resize'].forEach((event) => addWindowListener(event));
}
